export enum NotificationTypeEnum {
  CHARGING_PREPARING = 'charging_preparing',
  CHARGING_STARTED = 'charging_started',
  CHARGING_FINISHED = 'charging_finished',
  CHARGING_DOWNTIME = 'charging_downtime',
  STATION_DISCONNECTED = 'station_disconnected',
  SYSTEM_NEWS = 'system_news',
}

export interface AppNotification {
  id: string;
  user_id: string;
  type: NotificationTypeEnum;
  title: string;
  message: string;
  read_at: string | null;
  data: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface NotificationsPaginated {
  total: number;
  page: number;
  pageSize: number;
  unreadCount: number;
  data: AppNotification[];
}

/** Server-side filters for the notification feed. */
export interface NotificationsQueryFilters {
  /** Only unread notifications. */
  unreadOnly?: boolean;
  /** Notification types to include; empty/undefined = all. */
  types?: NotificationTypeEnum[];
  /** ISO timestamp lower bound (createdAt >=). */
  startDate?: string;
  /** ISO timestamp upper bound (createdAt <=). */
  endDate?: string;
}
